import { Injectable } from '@angular/core'

const SCREEN_SIZES =  [ 'xs', 'sm', 'md', 'lg', 'xl', 'xxl' ] as const
type ScreenSize = typeof SCREEN_SIZES[number]
const BREAKPOINTS = [ 0, 576, 768, 992, 1200, 1400 ]

@Injectable({ providedIn: 'root' })
export class BootstrapService {
  getBreakpoint (screenSize:ScreenSize): number {
    return BREAKPOINTS[SCREEN_SIZES.indexOf(screenSize)]
  }
  getScreenSize (screenWidth:number):ScreenSize{
    return SCREEN_SIZES[BREAKPOINTS.findIndex((breakpoint)=>screenWidth < breakpoint) - 1] ?? 'xxl'
  }
  getCurrentScreenSize (): ScreenSize {
    return this.getScreenSize(window.innerWidth)
  }
}
